import { useState } from "react";
import CustomButton from "../../components/Common/CustomButton";
import { toastError, toastSuccess } from "../../utils";
import * as actions from "./actions";
import AuthInput from "./AuthInput";

const initialUser = {
  email: "",
};

function ForgotPassword({ setView, initialEmail, setEmail }) {
  const [user, setUser] = useState({
    email: initialEmail || "",
  });
  const [loginLoader, setLoginLoader] = useState(false);

  const onChangeHandler = (e) => {
    const { name = "", value = "" } = e.target;
    setUser({ ...user, [name]: value });
    if (name === "email") {
      setEmail(value);
    }
  };

  const keyPressed = (e) => {
    if (e.key === "Enter") {
      if (!loginLoader) {
        onConfirmEmail();
      }
    }
  };

  const onConfirmEmail = () => {
    if (!user.email) return;
    setLoginLoader(true);
    actions
      .forgetPassword(user)
      .then((res) => {
        setLoginLoader(false);
        toastSuccess("Sent a reset password link on your email address");
        setUser({ ...initialUser });
      })
      .catch((err) => {
        setLoginLoader(false);
        toastError(err?.data?.message || "Failed to confirm email");
      });
  };

  return (
    <div className="flex flex-col gap-6 text-center">
      {/* Header Text */}
      <div className="flex flex-col gap-1.5 mb-2">
        <h2 className="text-2xl font-bold text-[#0a2540] tracking-tight">
          Forgot Password
        </h2>
        <p className="text-xs font-medium text-slate-400 max-w-[320px] mx-auto leading-relaxed">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      {/* Input field */}
      <div className="flex flex-col gap-4 text-left">
        <AuthInput
          name="email"
          type="email"
          placeholder="name@company.com"
          label="Email Address"
          value={user.email}
          onChange={onChangeHandler}
          onKeyPress={keyPressed}
        />
      </div>

      {/* Action Button */}
      <div className="flex flex-col gap-4 mt-2">
        <CustomButton
          onClick={onConfirmEmail}
          loader={loginLoader}
          disabled={loginLoader}
          className="bg-[#0a2540] hover:bg-[#001c3d] text-white py-3.5 rounded-2xl font-semibold tracking-wide shadow-lg shadow-[#0a2540]/10 hover:shadow-[#0a2540]/20 transition-all duration-300 w-full text-sm border-none cursor-pointer"
        >
          Confirm Email
        </CustomButton>
      </div>

      {/* Footer Link */}
      <div className="text-center pt-2">
        <p className="text-sm text-slate-500">
          Remember Password?{" "}
          <button
            type="button"
            onClick={() => setView("login")}
            className="text-[#313C4C] font-bold hover:text-sky-800 transition-colors duration-200 focus:outline-none cursor-pointer bg-transparent border-none"
          >
            Login
          </button>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
